import * as api from '../../../clients/api';

import {Action} from '@ngrx/store';

export const POST_SEND_WEB_SOCKET_TO_USER = '[ApiModul] PostSendWebSocketToUser laden';
export const POST_SEND_WEB_SOCKET_TO_USER_AUSFUEHREN = '[ApiModul] PostSendWebSocketToUser ausführen';
export const POST_SEND_WEB_SOCKET_TO_USER_ERFOLGREICH = '[ApiModul] PostSendWebSocketToUser laden erfolgreich';
export const POST_SEND_WEB_SOCKET_TO_USER_FEHLER = '[ApiModul] PostSendWebSocketToUser Ladefehler';
export const POST_SEND_WEB_SOCKET_TO_USER_NICHT_AUSGEFUEHRT = '[ApiModul] PostSendWebSocketToUser nicht ausgeführt (evtl. Offline)';


export class PostSendWebSocketToUserAction implements Action {
    readonly type = POST_SEND_WEB_SOCKET_TO_USER;
        constructor(public webSocketMessageRequest: api.WebSocketMessageRequest, public optPayload: any = null) {}
    }
export class PostSendWebSocketToUserAusfuehrenAction implements Action {
    readonly type = POST_SEND_WEB_SOCKET_TO_USER_AUSFUEHREN;
        constructor(public webSocketMessageRequest: api.WebSocketMessageRequest, public optPayload: any = null) {}
    }
export class PostSendWebSocketToUserErfolgreichAction implements Action {
    readonly type = POST_SEND_WEB_SOCKET_TO_USER_ERFOLGREICH;
        constructor(public webSocketMessageRequest: api.WebSocketMessageRequest, public optPayload: any = null) {}
    }
export class PostSendWebSocketToUserFehlerAction implements Action {
    readonly type = POST_SEND_WEB_SOCKET_TO_USER_FEHLER;
        constructor(public payload: any, public webSocketMessageRequest: api.WebSocketMessageRequest, public optPayload: any = null) {}
    }
export class PostSendWebSocketToUserNichtAusgefuehrtAction implements Action {
    readonly type = POST_SEND_WEB_SOCKET_TO_USER_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type ApiCommandSendWebSocketToUserActions =
    PostSendWebSocketToUserAction
    | PostSendWebSocketToUserAusfuehrenAction
    | PostSendWebSocketToUserErfolgreichAction
    | PostSendWebSocketToUserFehlerAction
    | PostSendWebSocketToUserNichtAusgefuehrtAction
    ;
